import axios from 'axios'
import { gengetURLTEST, genURL } from "../../_getjson";

export default async function CheckTaxgroup(code, tablename, search) {

    if (code) {
        let rs = "";
        var Url = "CSDOCGROUP/Code?tablename=" + tablename + "&code=" + code + "&user=" + localStorage.getItem("Username") + "&top=300";
        console.log("CheckTaxgroup", genURL(Url));
        await axios.get(genURL(Url), { timeout: 360 }).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].TAXGROUP
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};